import React from 'react';
import usePopupAnimation from '../utils/usePopupAnimation.js';

// Rám popupu se sekcí aplikace otevřenou z monitoringu pro konkrétního uživatele
// (platby, eshop, bonusy, uživatelé). Obsah je stejná komponenta jako na stránce
// sekce – popup jen dodá hlavičku, lištu (hledání, akce) a patičku se Zpět.
// Obsah se vykreslí až s popupem, takže se nic nenačítá, dokud není otevřený.
export default function SectionPopup({show, close, title, toolbar = null, loading = false, className = '', onNavigate, children}) {
	const popupAnimationMs = 300;
	const {shouldRender, isClosing} = usePopupAnimation(show, popupAnimationMs);

	// Proklik na jinou stránku aplikace (odkaz uvnitř obsahu) → popup zavřít,
	// jinak by cílová stránka zůstala schovaná pod ním. onNavigate zavře i mobilní monitor.
	const handleClickCapture = (event) => {
		if (event.target.closest && event.target.closest('a[href^="/"]')) {
			close();

			if (onNavigate) {
				onNavigate();
			}
		}
	};

	if (!shouldRender) {
		return null;
	}

	return (
		<div className={`popup section-popup${className !== '' ? ` ${className}` : ''}${isClosing ? ' popup--closing' : ''}`} onClickCapture={handleClickCapture}>
			{loading ? <div className="loading" /> : null}

			<div className={`popup_content section-popup__content${isClosing ? ' popup_content--closing' : ''}`}>
				<div className="popup_content_in_head">
					<div className="popup_content_in_head_in">{title}</div>
					<img
						alt=""
						className="popup_content_in_head_in-close"
						onClick={() => {
							close();
						}}
					/>
				</div>
				<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar section-popup__body">
					<div className="popup_content_in_body_in section-popup__body-in">
						{toolbar ? <div className="section-popup__toolbar">{toolbar}</div> : null}
						<div className="section-popup__main">{children}</div>
					</div>
				</div>
				<div className="popup_content_in_foot">
					<div className="popup_content_in_foot_in section-popup__foot">
						<button
							type="button"
							className="button"
							onClick={() => {
								close();
							}}
						>
							Zpět
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
